"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollCallback = void 0;
const react_1 = require("react");
function useScrollCallback({ headerRef }) {
    return (0, react_1.useCallback)(function ({ scrollLeft }) {
        var _a;
        (_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('transform', `translateX(-${Math.round(scrollLeft)}px)`);
    }, [headerRef]);
}
exports.useScrollCallback = useScrollCallback;
//# sourceMappingURL=useScrollCallback.js.map